import { render, staticRenderFns } from "./IconSortAplphabeticalReverse.vue?vue&type=template&id=855bf148&"
import script from "./IconSortAplphabeticalReverse.vue?vue&type=script&lang=js&"
export * from "./IconSortAplphabeticalReverse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('855bf148')) {
      api.createRecord('855bf148', component.options)
    } else {
      api.reload('855bf148', component.options)
    }
    module.hot.accept("./IconSortAplphabeticalReverse.vue?vue&type=template&id=855bf148&", function () {
      api.rerender('855bf148', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconSortAplphabeticalReverse.vue"
export default component.exports